import React from 'react';
import cx from 'classnames';

import { Content } from 'LegacySBCRA/Content/Content';

import { stepsConfig, stepsTitle } from '../../../../../components/steps/config/howToConfig';
import type { StepItemBlock } from '../../@types/landingPages';
import { Steps } from '../Steps/Steps';

import styles from './HowItWorks.scss';

type Props = {
  className?: string;
}

const mapConfigToSteps = (): StepItemBlock[] =>
  stepsConfig().map(({
    imgAvif, imgPng, imgWebp, text, time,
  }) => ({
    description: String(text),
    image: imgPng,
    imageAvif: imgAvif,
    imageWebp: imgWebp,
    title: time,
  }));

const HowItWorks = ({ className }: Props) => (
  <section className={cx(styles.stepsSectionWrapper, className)}>
    <Content>
      <Steps
        steps={mapConfigToSteps()}
        title={stepsTitle as string}
      />
    </Content>
  </section>
);

export default HowItWorks;
